import uniq from "lodash/uniq";

const searchOperationGenerator = (fieldData, defaultOperations = []) => {
  if (!fieldData || !Array.isArray(fieldData.operations)) {
    return uniq(defaultOperations);
  }
  return uniq([...fieldData.operations, ...defaultOperations]);
};

export default searchOperationGenerator;



// WEBPACK FOOTER //
// ./src/helpers/search-operation-generator.js